export var Globals = {
  appThis: null,
}



// WEBPACK FOOTER //
// ./src/Globals.js